import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🍽️',
    title: 'pages.onboarding.picturingQuestion.answer1',
  },

  {
    emoji: '🤝',
    title: 'pages.onboarding.picturingQuestion.answer2',
  },
  {
    emoji: '💼',
    title: 'pages.onboarding.picturingQuestion.answer3',
  },
  {
    emoji: '🏠',
    title: 'pages.onboarding.picturingQuestion.answer4',
  },
  {
    emoji: '❤️',
    title: 'pages.onboarding.picturingQuestion.answer5',
  },
  {
    emoji: '🎬',
    title: 'pages.onboarding.picturingQuestion.answer6',
  },
]

export default function PicturingQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      subtitle="pages.onboarding.picturingQuestion.subtitle"
      title="pages.onboarding.picturingQuestion.title"
    />
  )
}
